import moment from 'moment';

export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_DATE_BASE = 'yyyy-MM-dd';
export const UI_DATE_BASE = 'MM-dd-yyyy';

export function getInitDateState(date) {
  const nowDate = moment(date);
  const startOfWeek = nowDate.clone().startOf('week');
  const endOfWeek = nowDate.clone().endOf('week');

  return {
    startOn: startOfWeek.format(API_DATE_FORMAT),
    endOn: endOfWeek.format(API_DATE_FORMAT),
    date: nowDate.format(API_DATE_FORMAT),
  };
}

export function calculatePrevWeek(startOn) {
  const startOfWeek = moment.utc(startOn).subtract(7, 'd');
  const endOfWeek = startOfWeek.clone().endOf('week');

  return {
    startOn: startOfWeek.format(API_DATE_FORMAT),
    endOn: endOfWeek.format(API_DATE_FORMAT),
  };
}

export function calculateNextWeek(startOn) {
  const startOfWeek = moment.utc(startOn).add(7, 'd');
  const endOfWeek = startOfWeek.clone().endOf('week');

  return {
    startOn: startOfWeek.format(API_DATE_FORMAT),
    endOn: endOfWeek.format(API_DATE_FORMAT),
  };
}

export function setNewDate(date) {
  return {
    date: moment.utc(date).format(API_DATE_FORMAT),
  };
}

export function formatToAPIDateFormat(date) {
  return moment.utc(date).format(API_DATE_FORMAT);
}

export function getNowAPIDateTime() {
  return moment.utc().format(API_DATE_FORMAT);
}

export function isDateBetweenBounds({ startOn, endOn }) {
  return moment()
    .startOf('day')
    .isBetween(startOn, endOn, undefined, '[]');
}



// WEBPACK FOOTER //
// ./src/utils/schedule/date-formatter.js